import { render, staticRenderFns } from "./customEvent.vue?vue&type=template&id=5cd3cdcd&scoped=true"
import script from "./customEvent.vue?vue&type=script&lang=js"
export * from "./customEvent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cd3cdcd",
  null
  
)

export default component.exports